import { ref } from "vue";

const storedDarkMode = localStorage.getItem("darkMode") === "false" ? false : true;

export const isDarkMode = ref(storedDarkMode);

export function setDarkMode(value) {
  isDarkMode.value = value;
  localStorage.setItem("darkMode", value);
}

export function toggleDarkMode() {
  isDarkMode.value = !isDarkMode.value;
  localStorage.setItem("darkMode", isDarkMode.value);
}
